import { z } from 'zod'

import {
  createWebComponentPropertyDescriptor,
  webComponentAttributeParsers,
} from '@salsita-ai/platform-project-sdk/domain'
import { useWebComponentPropertyValue } from '@salsita-ai/platform-project-sdk/react'

export const higginsAttributes = {
  session: createWebComponentPropertyDescriptor({
    schema: z.string(),
    defaultValue: undefined,
    attributeParser: webComponentAttributeParsers.string,
  }),
  'add-to-cart-url': createWebComponentPropertyDescriptor({
    schema: z.string(),
    defaultValue: undefined,
    attributeParser: webComponentAttributeParsers.string,
  }),
  'cart-url': createWebComponentPropertyDescriptor({
    schema: z.string(),
    defaultValue: undefined,
    attributeParser: webComponentAttributeParsers.string,
  }),
  locale: createWebComponentPropertyDescriptor({
    schema: z.string(),
    defaultValue: undefined,
    attributeParser: webComponentAttributeParsers.string,
  }),
} as const

export const useHigginsAttributes = () => {
  return {
    session: useWebComponentPropertyValue(higginsAttributes.session),
    addToCartUrl: useWebComponentPropertyValue(higginsAttributes['add-to-cart-url']),
    cartUrl: useWebComponentPropertyValue(higginsAttributes['cart-url']),
    locale: useWebComponentPropertyValue(higginsAttributes.locale),
  }
}

export const useHigginsLanguage = () => {
  const { locale } = useHigginsAttributes()
  return locale?.split('-')[0] ?? 'en'
}
